Object.defineProperty(exports, '__esModule', { value: true });

function getDefaultWeight(font, platform) {
    if (font === 'styrene') {
        return 'medium';
    }
    if (platform === 'desktop') {
        return 'bold';
    }
    return 'semibold';
}

exports.getDefaultWeight = getDefaultWeight;
